import { render, staticRenderFns } from "./AttachmentsInfo.vue?vue&type=template&id=6fa89772&scoped=true&"
import script from "./AttachmentsInfo.vue?vue&type=script&lang=ts&"
export * from "./AttachmentsInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentsInfo.vue?vue&type=style&index=0&id=6fa89772&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa89772",
  null
  
)

export default component.exports